var map = {
	"./Olympisk2025.jpg": "e2e4",
	"./Satertriathlon_logo_vit.jpg": "919e",
	"./bike.jpg": "81f5",
	"./bikes.jpg": "161a",
	"./brygga.jpg": "9907",
	"./group.png": "1390",
	"./lokalt.png": "e61b",
	"./map.png": "8708",
	"./maps.png": "f655",
	"./newsImg.jpg": "24e8",
	"./newsImg2.png": "16ec",
	"./rebuild.jpg": "8465",
	"./saterkommun.jpg": "3107",
	"./starttider.jpg": "01ed",
	"./strand.png": "24ba",
	"./swimmers-2.jpg": "1671",
	"./swimmers.jpg": "8f71",
	"./umara.png": "f90b",
	"./wheels.jpg": "7036"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";